<template>
	<div data-tour-scope="affiliate-dashboard">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation="0">
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>Affiliate Dashboard</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer></v-spacer>
							<v-toolbar-items> </v-toolbar-items>
						</v-toolbar>

						<v-col cols="12">
							<v-row>
								<v-col cols="12" md="4" data-tour="search">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense hide-details @click:append="getSearch" @keyup.enter="getSearch" />
								</v-col>
								<v-col cols="12" md="5" data-tour="period">
									<v-menu v-model="dateMenu" :close-on-content-click="false" offset-y min-width="290px">
										<template #activator="{ on, attrs }">
											<v-text-field
												:value="computedDateRange"
												label="Periodo link"
												outlined
												dense
												hide-details
												clearable
												readonly
												prepend-inner-icon="mdi-calendar-range"
												v-bind="attrs"
												v-on="on"
												@click:clear="resetDateRangeToCurrentMonth"
											/>
										</template>
										<v-date-picker v-model="dateRange" range @change="onDateRangeChange" />
									</v-menu>
								</v-col>
								<v-col cols="12" md="3">
									<div class="d-flex align-center" style="gap: 8px">
										<v-btn color="primary" outlined @click="dateMenu = true">
											<v-icon left>mdi-calendar-range</v-icon>
											Seleziona periodo
										</v-btn>
										<v-btn text @click="resetDateRangeToCurrentMonth">Mese corrente</v-btn>
									</div>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table data-tour="table" :hide-default-header="mobileCards" :class="{ 'table-cards': mobileCards }" :headers="headers" :items="getItems" :options.sync="settings.options" :server-items-length="total" must-sort class="elevation-0" :footer-props="{ 'items-per-page-options': listSize }">
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="affiliate-dash-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :fields="campiCard(item)">
												<template v-slot:title>
													<span>{{ nomePartner(item) || 'Partner' }}</span>
												</template>
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon v-bind="attrs" v-on="on" color="primary" small data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-primary" @click="openOrders(item)">
																<v-list-item-title class="size9">Ordini</v-list-item-title>
															</v-list-item>
															<v-list-item link @click="openInvoices(item)">
																<v-list-item-title class="size9">Fatture</v-list-item-title>
															</v-list-item>
															<v-list-item link @click="recalculateItem(item)">
																<v-list-item-title class="size9">Ricalcola</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<div class="d-flex align-center justify-space-between">
													<span class="card-label">Attivo</span>
													<v-switch v-model="item.active" data-tour="status" color="primary" class="mt-0 pt-0" dense hide-details @change="changeStatus(item)"></v-switch>
												</div>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="item in items" :key="item._id">
										<td class="pl-0 pr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
											<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
														<v-icon dark>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list>
											<v-list-item link data-tour="row-primary" @click="openOrders(item)">
														<v-list-item-title class="size9">Ordini</v-list-item-title>
													</v-list-item>
													<v-list-item link @click="openInvoices(item)">
														<v-list-item-title class="size9">Fatture</v-list-item-title>
													</v-list-item>
													<v-list-item link @click="recalculateItem(item)">
														<v-list-item-title class="size9">Ricalcola</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td>
									<v-switch v-model="item.active" data-tour="status" color="primary" class="mt-0" hide-details @change="changeStatus(item)"></v-switch>
										</td>
										<td>{{ item.created_at | moment('DD/MM/YYYY') }}</td>
										<td>{{ item.name }}</td>
										<td>{{ item.lastname }}</td>
										<td>{{ item.email }}</td>
										<td>{{ item.phone }}</td>
										<td>{{ item.fee }}</td>
										<td>{{ item.website }}</td>
										<td>{{ item.links_count || 0 }}</td>
										<td>{{ formatCommission(item.commission_total) }}</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Confermando verranno ricalcolate commissioni e fatture per questo partner.</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>
					<v-btn color="primary" text @click="confirmRecalculate"> Conferma </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
			<span v-html="snackbar.text"></span>
			<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
		</v-snackbar>
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createDashboardTourSteps, stopAffiliateListTour } from './affiliate-list-tours';
import { listRouteState } from '@/components/core/list/listRouteState';

const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'AffiliateDashboard',
	components: {
		TourOverlay,
		KeyValueCard,
	},
	// pagina, righe, ordinamento, ricerca e periodo stanno nell'URL (di default il mese corrente):
	// refresh e ritorno da Ordini/Fatture ripartono da li'
	mixins: [listRouteState({ filters: { created_at: 'array' }, perPageOptions: LIST_SIZE })],
	setup() {
		return { tour: useTour(createDashboardTourSteps(), { onStop: () => stopAffiliateListTour('affiliate-dashboard') }) };
	},
	data() {
		return {
			total: 0,
			dateMenu: false,
			// selezione in corso nel calendario: diventa filtro solo quando l'intervallo e' completo
			dateRange: [],
			dialogconfirm: false,
			selectedRecalculateItem: null,
			listSize: LIST_SIZE,
			searchfield: '',
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {
					created_at: this.getCurrentMonthRange(),
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),
			headers: [
				{ text: '', value: 'actions', sortable: false },
				{ text: 'Status', value: 'active', sortable: true },
				{ text: 'Created', value: 'created_at', sortable: true },
				{ text: 'Nome', value: 'name', sortable: true },
				{ text: 'Cognome', value: 'lastname', sortable: true },
				{ text: 'Email', value: 'email', sortable: true },
				{ text: 'Telefono', value: 'phone', sortable: true },
				{ text: 'Fee', value: 'fee', sortable: true },
				{ text: 'Sito internet', value: 'website', sortable: true },
				{ text: 'Link periodo', value: 'links_count', sortable: true },
				{ text: 'Commissioni periodo', value: 'commission_total', sortable: true },
			],
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
		};
	},
	computed: {
		...mapGetters({
			getItems: 'partners/getItems',
		}),
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		computedDateRange() {
			if (this.settings.filters.created_at.length > 0) {
				return this.settings.filters.created_at.map(value => moment(value).format('DD/MM/YYYY')).join(' ~ ');
			}
			return '';
		},
	},
	created() {
		this.listLoad();
	},
	watch: {
		// il calendario riparte dal periodo applicato
		dateMenu(open) {
			if (open) {
				this.dateRange = [...(this.settings.filters.created_at || [])];
			}
		},
	},
	methods: {
		...mapActions({
			fetchItems: 'partners/asyncFetchData',
			patchPartner: 'partners/patchItem',
			recalculatePartner: 'partners/recalculatePartner',
		}),
		async getDataFromApi() {
			const result = await this.fetchItems(this.settings);
			if (result) {
				this.total = result.total;
			}
		},
		// ricerca da tre caratteri; il caricamento lo fa listRouteState
		getSearch() {
			this.settings.search = _.size(this.searchfield) >= 3 ? this.searchfield : '';
		},
		getCurrentMonthRange() {
			const today = new Date();
			const start = new Date(today.getFullYear(), today.getMonth(), 1);
			const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);

			return [
				`${start.getFullYear()}-${(start.getMonth() + 1).toString().padStart(2, '0')}-${start.getDate().toString().padStart(2, '0')}`,
				`${end.getFullYear()}-${(end.getMonth() + 1).toString().padStart(2, '0')}-${end.getDate().toString().padStart(2, '0')}`,
			];
		},
		// ritorno a pagina 1 e ricaricamento li fa listRouteState
		resetDateRangeToCurrentMonth() {
			this.settings.filters.created_at = this.getCurrentMonthRange();
			this.dateMenu = false;
		},
		onDateRangeChange(value) {
			if (!Array.isArray(value) || value.length === 0) {
				this.resetDateRangeToCurrentMonth();
				return;
			}

			const range = [...value].sort();
			if (range.length === 2) {
				this.settings.filters.created_at = range;
				this.dateMenu = false;
			}
		},
		formatCommission(value) {
			return Number(value || 0).toFixed(2);
		},
		nomePartner(item) {
			return [item.name, item.lastname].filter(Boolean).join(' ');
		},
		// campi in sola lettura della card da telefono
		campiCard(item) {
			return [
				{ label: 'Creato', value: item.created_at ? moment(item.created_at).format('DD/MM/YYYY') : '' },
				{ label: 'Email', value: item.email },
				{ label: 'Telefono', value: item.phone },
				{ label: 'Fee', value: item.fee },
				{ label: 'Sito internet', value: item.website },
				{ label: 'Link periodo', value: item.links_count || 0 },
				{ label: 'Commissioni periodo', value: this.formatCommission(item.commission_total), strong: true },
			];
		},
		openOrders(item) {
			if (!item?._id) {
				return;
			}

			const query = {};
			if (Array.isArray(this.settings.filters.created_at) && this.settings.filters.created_at.length === 2) {
				query.from = this.settings.filters.created_at[0];
				query.to = this.settings.filters.created_at[1];
			}

			this.$router.push({
				name: 'affiliate-dashboard-orders',
				params: { id: item._id },
				query,
			});
		},
		openInvoices(item) {
			if (!item?._id) {
				return;
			}

			this.$router.push({
				name: 'affiliate-dashboard-invoices',
				params: { id: item._id },
			});
		},
		recalculateItem(item) {
			if (!item?._id) {
				return;
			}
			this.selectedRecalculateItem = item;
			this.dialogconfirm = true;
		},
		async confirmRecalculate() {
			if (!this.selectedRecalculateItem?._id) {
				this.dialogconfirm = false;
				return;
			}

			try {
				const response = await this.recalculatePartner({ partner_id: this.selectedRecalculateItem._id });
				await this.getDataFromApi();
				this.dialogconfirm = false;
				this.selectedRecalculateItem = null;
				const stats = response?.data?.invoicing || {};
				this.snackbar.color = 'success';
				this.snackbar.text = `Ricalcolo completato. Ordini: ${stats.eligible_orders || 0}, fatture: ${stats.invoices || 0}, email: ${stats.emails || 0}`;
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 4000;
			} catch (e) {
				this.snackbar.color = 'error';
				this.snackbar.text = 'Errore durante il ricalcolo partner';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 4000;
			}
		},
		async changeStatus(item) {
			try {
				await this.patchPartner({ _id: item._id, active: !!item.active });
				this.snackbar.color = 'success';
				this.snackbar.text = 'Status partner aggiornato';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 3000;
			} catch (e) {
				item.active = !item.active;
				this.snackbar.color = 'error';
				this.snackbar.text = 'Errore durante aggiornamento status partner';
				this.snackbar.snackbar = true;
				this.snackbar.mode = 'multi-line';
				this.snackbar.timeout = 4000;
			}
		},
	},
	beforeDestroy() {
		this.tour.stop();
		this.$store.dispatch('partners/destroyData');
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.affiliate-dash-cards,
.affiliate-dash-cards tr {
	display: block;
	width: 100%;
}
.affiliate-dash-cards tr,
.affiliate-dash-cards tr:hover {
	background: transparent !important;
}
.affiliate-dash-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.affiliate-dash-cards tr:first-child td {
	padding-top: 12px !important;
}
.affiliate-dash-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.affiliate-dash-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
